export default {"src":"/_next/static/media/breakdown.8bda2f3f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};